/** How far apart the lines of one operation are drawn, at most. */
export const LANE_GAP_PX = 8;
/**
 * The widest an operation's fan may be when its day is narrower than this (a zoomed-out board,
 * where a day is a pixel or two): wide enough to tell three lines apart.
 */
export const MIN_FAN_PX = 24;

const DAY_MS = 24 * 60 * 60 * 1000;

/** One day's width on a track `trackPx` wide over the axis from `startMs` to `endMs`. */
export function dayWidthPx(trackPx: number, startMs: number, endMs: number): number {
    return (trackPx * DAY_MS) / Math.max(endMs - startMs, DAY_MS);
}

/**
 * The gap between the `lineCount` lines of one operation, centred on its date: 8px, closer
 * when that fan wouldn't fit inside the operation's day (or the small minimum fan).
 */
export function laneGapPx(lineCount: number, dayPx: number): number {
    if (lineCount < 2) return LANE_GAP_PX;
    return Math.min(LANE_GAP_PX, Math.max(dayPx, MIN_FAN_PX) / (lineCount - 1));
}

/**
 * Where each line's pointer target runs, in px from the date: as wide as the gap and centred
 * on its line, so neighbours meet at the half-gap and the line nearest the pointer takes it.
 * `lane` is the line's place, centred on 0 (-1, 0, 1 for three).
 */
export function laneHitArea(lane: number, gapPx: number): [number, number] {
    return [lane * gapPx - gapPx / 2, lane * gapPx + gapPx / 2];
}
